<template>
  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[10, 20, 50, 100]"
    :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total">
  </el-pagination>
</template>

<script>
  import VueEvent from "@/models/VueEvent.js";
  export default {
    data() {
      return {
        size: 10,
        page: 1,
        total: 0
      };
    },
    mounted() {
      VueEvent.$on("data_loaded", params => {
        if (params.origin == this.target) {
          this.total = params.total;
        }
      });
      this.onchange();
    },
    props: ["target"],
    methods: {
      handleSizeChange(a) {
        this.size = a;
        this.onchange();
      },
      handleCurrentChange(a) {
        this.page = a;
        this.onchange();
      },
      onchange() {
        if (this.target) {
          VueEvent.$emit("addCondition", {
            target: this.target,
            condition: {
              page: this.page,
              size: this.size
            }
          });
        }
      }
    }
  };

</script>

<style scoped>
  .el-pagination {
    margin-top: 10px;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/PageNations/Complete.vue